export default __webpack_public_path__ + "bf50ebce1dea651a4e0fcdf7eaa983c0.png";